import script from "./date-picker.vue?vue&type=script&lang=ts&setup=true"
export * from "./date-picker.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__